import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames/bind';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { findMobileOS, getPathFromUrl } from 'yoda-core-components/lib/helpers/Utils/Utils';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import List from 'yoda-core-components/lib/components/List/List';
import {
    getScrolledElementOffSet,
    getDefaultOffSet,
    setDefaultOffSet,
} from '../../helpers/Utils/scrollPosition';
import { isGalleryPage } from '../../helpers/Utils/pageType';
import ProductCardConnected from '../ProductCard/ProductCard';
import QuickAddToCartConnected from '../QuickAddTocart/QuickAddToCart';
import { cardTypes } from '../ProductCard/ProductCard.config';
import { triggerEnsightenEvent } from '../../actions/ProductCartridgeAction';
import getUrgencyStatementsAction from '../../actions/UrgencyMessagingAction';
import UrgencyMessage from '../UrgencyMessageContainer/UrgencyMessageLazy';
import * as styles from './YodaProductCartridge.css';
import Carousel from '../Carousel';
import { selectUrgencyMessages } from '../../selectors/fromState';
import {
    selectContext,
    selectDeviceType,
    selectIsNative,
    selectFeatureFlags,
    selectPreferencesRecommendations,
    selectPreferencesUrgencyApiUrl,
} from '../../selectors/ContextSelector';

const cx = classNames.bind(styles);

/* istanbul ignore next */
const miniPDP = (item, url, id, context) => {
    const themeConfig = {
        wrapperClass: cx('cartridgeWrapper', 'noPad'),
        buttonCustomClass: styles.cartridgeMiniPDPBtn,
    };
    return (
        /* eslint-disable no-return-assign */
        <div ref={(node) => (context.quickAddToCartRefs[id] = node)}>
            <QuickAddToCartConnected
                enableMiniPDP={item.enableMiniPDP}
                ppId={item.id}
                url={url}
                iconStyle
                automationId="miniPDPAddtoCart"
                location="hp-cartridge"
                themeConfig={themeConfig}
            />
        </div>
    );
};

/* istanbul ignore next */
const YodaProductCartridge = (props) => {
    const {
        productCartridgeList,
        enableUrgencyMessagingOnATC,
        slotId,
        onPaneClick,
        isPLAEnabled,
        showPaneLoader,
        showImageLoader,
        pricingConfig,
        pricingConfig: { disableFPACAPI },
        showPricing,
        enableMiniPDP,
        productItemClass,
        isCouponRecommendationsModal,
        criteriaName,
        enableGridViewInCertona,
        customRenderProductCard,
        cartridgeListRenderer,
        highlightCardSlot,
        panelType,
        cartridgeHeader,
        panelTitle,
        productCatridgeTheme,
        hasTitle,
        fromMiniPDP,
        fromHotDeals,
        pageType,
    } = props;
    const quickAddToCartRefs = {};

    const context = useSelector(selectContext);
    const urgencyMessages = useSelector(selectUrgencyMessages);
    const deviceType = useSelector(selectDeviceType);
    const isNative = useSelector(selectIsNative);
    const {
        disableRRZoneLazyLoad = false,
        enableAnchoring = false,
        pdpBreadCrumbzScrollTop = true,
    } = useSelector(selectFeatureFlags);
    const recommendations = useSelector(selectPreferencesRecommendations);
    const URGENCY_API_URL = useSelector(selectPreferencesUrgencyApiUrl);

    let cartridgeRef = useRef(null);

    const dispatch = useDispatch();
    const history = useHistory();
    const {
        location: { pathname = '' },
    } = history;

    const [imageHeight, setImgHeight] = useState(null);

    useEffect(() => {
        if (productCartridgeList?.length > 0) {
            fireEnsightenEvent(productCartridgeList);
            const ppIds = productCartridgeList.map((obj) => obj.id);
            enableUrgencyMessagingOnATC &&
                !isEmpty(ppIds) &&
                dispatch(
                    getUrgencyStatementsAction({
                        ppid: ppIds,
                        apiURL: URGENCY_API_URL,
                    })
                );
        }

        const isGallery = isGalleryPage(pathname);
        if (isGallery && enableAnchoring) {
            const scrollToCartridgeVal = LocalStorage.getData('scrollToCartridge', true);
            const parsedJson = scrollToCartridgeVal && JSON.parse(scrollToCartridgeVal);
            const galleryScrollToVal =
                parsedJson?.val && parsedJson?.key === window.location.href ? parsedJson?.val : {};
            if (!isEmpty(parsedJson)) {
                const pdpBreadCrumbsClickData = LocalStorage.getData('pdpBreadCrumbsClick');
                const isScrollTop = pdpBreadCrumbsClickData && pdpBreadCrumbzScrollTop;
                if (!isEmpty(galleryScrollToVal) && !isScrollTop) {
                    const { galleryScrollTo } = galleryScrollToVal;
                    if (
                        /* adding replace as few times when we came back from pdp to plp
                        same data populating same slot name with different number */
                        galleryScrollTo?.replace(/[0-9]/g, '') === slotId.replace(/[0-9]/g, '')
                    ) {
                        cartridgeRef.scrollIntoView({ behaviour: 'smooth' });
                    }
                } else if (!__SERVER__) {
                    window.scroll({ top: 0, behavior: 'smooth' });
                }
                LocalStorage.removeData('scrollToCartridge', true);
                LocalStorage.removeData('galleryScrollToOffSet');
                LocalStorage.removeData('pdpBreadCrumbsClick');
            }
        }
    }, []);

    const handleOnPaneClick = (e, dataItem, linkUrlWithSlotId) => {
        const { index = 0, id = 0 } = dataItem;
        if (onPaneClick) {
            e.preventDefault();
            e.stopPropagation();
            onPaneClick(
                index,
                linkUrlWithSlotId,
                productCartridgeList[index],
                quickAddToCartRefs[id] && quickAddToCartRefs[id].contains(e.target)
            );
        }

        const isGallery = isGalleryPage(pathname);
        if (isGallery && enableAnchoring) {
            const scrollKeyVal = {
                galleryScrollTo: slotId,
            };
            const scrollKey = { key: window.location.href, val: scrollKeyVal };
            scrollKeyVal && LocalStorage.setData('scrollToCartridge', scrollKey, true, '', false);
            // this is to set exact position where user clicked
            LocalStorage.setData('galleryScrollToOffSet', getScrolledElementOffSet());
            isNative &&
                findMobileOS() === 'iOS' &&
                setDefaultOffSet(id, 'nativeGalleryScrollToOffSet');
        }
    };

    const defaultProductCardRenderer = (dataItem, index) => {
        const {
            linkURL = '',
            imageURL = '',
            name = '',
            rating = 0,
            reviews = '',
            skuId = '',
            skuSwatch = [],
            priceDetails = {},
            id = null,
            fromMiniPDP = false,
        } = dataItem;
        const recommendationsMap = get(recommendations, 'adobeMap', {});
        const rrPlacementType = recommendationsMap[slotId] || slotId;
        /* istanbul ignore next */
        let linkUrlWithSlotId =
            slotId && linkURL ? linkURL.concat(`&rrplacementtype=${rrPlacementType}`) : linkURL;
        linkUrlWithSlotId = criteriaName
            ? `${linkUrlWithSlotId}&criteriaName=${criteriaName}`
            : linkUrlWithSlotId;
        const linkwithoutHostName = getPathFromUrl(linkUrlWithSlotId);
        const enableNewPriceFormat = disableFPACAPI === false;
        const currentUrgencyMessage = enableUrgencyMessagingOnATC ?? get(urgencyMessages, id, {});
        const prodCardStyle = cx('productCard', {
            miniPdpProductCard: enableMiniPDP,
            productCatridge: !enableMiniPDP,
            cartridgeNewPriceWrapper: enableNewPriceFormat,
        });
        const productCardProps = {
            lazyLoadImages: !enableGridViewInCertona && !disableRRZoneLazyLoad,
            customClass: prodCardStyle,
            imageUrl: imageURL,
            title: !isPLAEnabled ? name : null,
            price: priceDetails,
            pricingConfig,
            key: id,
            cardType: cardTypes?.GRID,
            rating: !isPLAEnabled ? Number(rating) : 0,
            reviewCount: !isPLAEnabled ? reviews : 0,
            cardTheme: 'cartridge',
            cardCustomClass: cx({
                miniPdpCard: fromMiniPDP,
            }),
            skuId,
            skuSwatch,
            automationId: 'product-cartridge-product-list',
            showPaneLoader,
            showImageLoader,
            showPricing,
            deviceType,
            eligibilityMessage: (priceDetails || {}).eligibilityMessage || '',
            isCouponRecommendationsModal,
            enableGridViewInCertona,
            defaultOffSet: getDefaultOffSet('galleryScrollToOffSet', false) || 1000,
            setImageHeight: index === 0 ? (el) => setImageHeight(el) : null,
            fromMiniPDP,
        };
        return (
            <>
                <a
                    href={linkwithoutHostName}
                    className={cx('linkColor', 'productPanelLinkBlock', productItemClass, {
                        couponRecommendationsPaneLink: isCouponRecommendationsModal,
                    })}
                    data-automation-id="reczone-link"
                    onClick={(e) => {
                        handleOnPaneClick(e, dataItem, linkwithoutHostName);
                    }}
                >
                    {!isEmpty(currentUrgencyMessage) ? (
                        <span>
                            <UrgencyMessage
                                urgencyStatements={currentUrgencyMessage}
                                className={cx('urgencyMessage')}
                            />
                        </span>
                    ) : null}
                    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                    <ProductCardConnected {...productCardProps}>
                        {enableMiniPDP ? miniPDP(dataItem, linkUrlWithSlotId, id, context) : false}
                    </ProductCardConnected>
                </a>
            </>
        );
    };

    const setImageHeight = (el) => {
        el && setImgHeight(el.offsetHeight);
    };

    const productCardRenderer = (dataItem, index) => {
        if (customRenderProductCard) {
            return cartridgeListRenderer(dataItem, context, highlightCardSlot, setImageHeight);
        }

        return defaultProductCardRenderer(dataItem, index);
    };

    const fireEnsightenEvent = (productList) => {
        /**
         * stripping zero priced product items
         */
        const isPriceEmpty = (item) =>
            (!item?.originalMax || item?.originalMax === '0') &&
            (!item?.originalMin || item?.originalMin === '0') &&
            (!item?.currentMin || item?.currentMin === '0') &&
            (!item?.currentMax || item?.currentMax === '0');

        const ppIds = productList.reduce((result, item) => {
            const { priceDetails, ppId, id } = item;
            if (
                (panelType === 'HOTDEAL' && isPriceEmpty(item)) ||
                (panelType === 'CERTONA' && !priceDetails)
            ) {
                result.push(ppId || id);
            }
            return result;
        }, []);
        if (ppIds?.length > 0) {
            dispatch(
                triggerEnsightenEvent({
                    pageType,
                    errorType: 'Price Not Found',
                    errorDescription: `${
                        cartridgeHeader || panelTitle
                    }: No price info for ${ppIds.join(',')}`,
                })
            );
        }
    };

    const carouselItemList = (dataItems) => {
        return dataItems?.map((item, index) => {
            if (!item?.index) item.index = index;
            return productCardRenderer(item, index);
        });
    };
    let titleGrid = '';
    let cartridgeGrid = '';
    if (isPLAEnabled) {
        titleGrid = 'lg2 xl2';
        cartridgeGrid = 'lg10 xl10';
    }
    const productCartridgeLength = productCartridgeList?.length;

    const carouselTheme = () => {
        if (fromMiniPDP || pageType === 'ADDTOCART') return 'inslider-carousel';
        if (fromHotDeals) return 'hotdeals-carousel';
        return 'rrzones-carousel';
    };

    const listStyleClass = dt(['p-0', '!flex', 'flex-wrap']);
    const listItemStyle = dt([
        'lg:w-1/4',
        'md:w-1/3',
        'sm:w-1/2',
        '!p-2',
        'smOnly:odd:!pl-0',
        'smOnly:even:!pr-0',
    ]);
    const girdViewInCertona = pageType === 'ADDTOCART' && enableGridViewInCertona;
    const titleGridStyle = girdViewInCertona ? dt(['md:!pl-2']) : '';
    const titleTextStyle = girdViewInCertona ? dt(['!pb-0']) : '';

    return productCartridgeLength ? (
        <section
            className={cx('productCartridge', productCatridgeTheme, {
                newProdCardWrapper: disableFPACAPI === false,
            })}
            ref={(wrapper) => {
                if (!isPLAEnabled && wrapper) cartridgeRef = wrapper;
            }}
        >
            {hasTitle ? (
                <h5
                    data-automation-id="product-catridge-title"
                    className={[
                        cx('productCartridgeTitle', titleGrid, {
                            'pdp-title': pageType === 'PRODUCT',
                            titlePLA: isPLAEnabled,
                        }),
                        titleGridStyle,
                        titleTextStyle,
                    ].join(' ')}
                >
                    {cartridgeHeader}
                </h5>
            ) : null}
            {girdViewInCertona ? (
                <List
                    datasource={productCartridgeList}
                    listStyleClass={listStyleClass}
                    itemStyleClass={listItemStyle}
                    childRenderer={productCardRenderer}
                    automationId="product-cartridge-list"
                    spacing="None"
                />
            ) : (
                <div className={cx('prodCatridgeListBlock', cartridgeGrid)} id={slotId}>
                    <Carousel
                        theme={carouselTheme()}
                        automationId="reczoneCarousel"
                        automationItemId="reczones-item"
                        // eslint-disable-next-line react/no-children-prop
                        children={carouselItemList(productCartridgeList)}
                        contentWrapperClass={dt(['smMd:px-6', 'smMd:pb-3'])}
                        carouselImageHeight={imageHeight}
                    />
                </div>
            )}
        </section>
    ) : null;
};

YodaProductCartridge.defaultProps = {
    customRenderProductCard: false,
    cartridgeListRenderer: null,
    productCatridgeTheme: '',
    cartridgeHeader: '',
    onPaneClick: false,
    hasTitle: true,
    isPLAEnabled: false,
    disableLazyLoad: false,
    showPaneLoader: false,
    showImageLoader: false,
    pageType: '',
    panelType: '',
    panelTitle: '',
    enableMiniPDP: false,
    pricingConfig: {},
    actions: {},
    showPricing: true,
    productItemClass: '',
    enableGridViewInCertona: false,
    enableUrgencyMessagingOnATC: false,
    highlightCardSlot: false,
    isCouponRecommendationsModal: false,
    fromMiniPDP: false,
    criteriaName: '',
    fromHotDeals: false,
};

YodaProductCartridge.propTypes = {
    /**
     * Each product cartridge slot requires unique slotId because a page can consists of multiple product cartridge slots.
     */
    slotId: PropTypes.string.isRequired,
    /**
     * The custom render function for rendering product cards
     */
    cartridgeListRenderer: PropTypes.func,
    /**
     * Flag to check if the lazy loading is disabled
     */
    disableLazyLoad: PropTypes.bool,
    /**
     * Flag to check if renderProductCard method has to be called.
     */
    customRenderProductCard: PropTypes.bool,
    productCatridgeTheme: PropTypes.string,
    /**
     * list of items to be shown in cartridge.
     * format: productCartridgeList: [{
     *  name: <name>,
     *   id: <ppid>,
     *   imageURL: <complete url>,
     *   rating: <number>,
     *   reviews: <number>,
     *   priceDetails: <{amounts: [], manufacturerAdvertised: <>, marketingLabel: <>, id: <>}>,
     *   skuId: <skuid>,
     *   linkURL: <pdp url>
     * }, ...]
     */
    productCartridgeList: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
    /**
     * Text to be displayed as header
     */
    cartridgeHeader: PropTypes.string,
    /**
     * callback on pane click
     */
    onPaneClick: PropTypes.func,
    /**
     * Flag to find pla ads
     */
    isPLAEnabled: PropTypes.bool,
    /**
     * Flag to show pane loader or not
     */
    showPaneLoader: PropTypes.bool,
    /**
     * Flag to show image loader or not
     */
    showImageLoader: PropTypes.bool,
    /**
     * Flag to show minipdp
     */
    enableMiniPDP: PropTypes.bool,
    /**
     * pageType to send Event
     */
    pageType: PropTypes.string,
    /**
     * panelType to send Event
     */
    panelType: PropTypes.string,
    /**
     * panelTitle to send Event
     */
    panelTitle: PropTypes.string,
    pricingConfig: PropTypes.object,
    showPricing: PropTypes.bool,
    productItemClass: PropTypes.string,
    actions: PropTypes.object,
    enableGridViewInCertona: PropTypes.bool,
    /**
     * flag to display Urgency Messages in Add To Cart
     */
    enableUrgencyMessagingOnATC: PropTypes.bool,
    /**
     * Urgency Messages for Add To Cart products
     */
    highlightCardSlot: PropTypes.bool,
    hasTitle: PropTypes.bool,
    isCouponRecommendationsModal: PropTypes.bool,
    fromMiniPDP: PropTypes.bool,
    criteriaName: PropTypes.string,
    location: PropTypes.object.isRequired,
    fromHotDeals: PropTypes.bool,
};

/* istanbul ignore next */
export default YodaProductCartridge;
